<template>
  <div class="me">
    <div class="me-warp">
      <div class="me-title1">账号设置</div>

      <div class="me-tou">
        <div class="one">
          <span class="left">
            <span>头像</span>
            <span><img :src="Data.image"/></span>
          </span>
          <span
            class="right"
            v-if="!datalist.touxiang"
            @click="datalist.touxiang = true"
            >更换头像</span
          >
          <span class="right1" v-else>
            <div @click="chushihua">取消</div>
            <div @click="changePhoto">保存</div>
          </span>
        </div>
        <div class="touxiang" v-if="datalist.touxiang">
          <div v-for="(item, index) in touxiang">
            <div @click="changeToux(index)">
              <img
                :src="item.image"
                :class="{ selectToux: index == selectToux }"
                alt=""
              />
            </div>
          </div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="one">
          <span class="left">
            <span>昵称</span>
            <span v-if="!datalist.userName">{{ Data.name }}</span>
            <span v-else
              ><input
                type="text"
                placeholder="请输入昵称"
                v-model="dlist.userName"
                class="long"
            /></span>
          </span>
          <span
            class="right"
            v-if="!datalist.userName"
            @click="datalist.userName = true"
            >修改昵称</span
          >
          <span class="right1" v-else>
            <div @click="chushihua">取消</div>
            <div @click="getName">保存</div>
          </span>
        </div>
        <div class="one">
          <span class="left">
            <span>密码</span>
            <span v-if="!datalist.passWord">******</span>
            <span v-else
              ><input
                type="text"
                placeholder="请输入新密码"
                v-model="dlist.passWord"
                class="long"
            /></span>
          </span>
          <span
            class="right"
            v-if="!datalist.passWord"
            @click="datalist.passWord = true"
            >修改密码</span
          >
          <span class="right1" v-else>
            <div @click="chushihua">取消</div>
            <div @click="openPass">保存</div>
          </span>
        </div>
        <div class="extend1" v-if="datalist.passWord">
          <span
            >短信验证<input
              type="text"
              placeholder="请输入短信验证码"
              class="long"
              v-model="dlist.passWordCode"
          /></span>
          <span @click="getCode(0)">获取验证码</span>
        </div>
        <div class="one">
          <span class="left">
            <span>{{ inviteImg?'邀请人':'关联邀请码'}}</span>
            <span style="display: flex;
    align-items: center;">
              <input
              v-if="!inviteImg"
                type="text"
                placeholder="请填写邀请码"
                v-model="tuiguangren"
                class="long"
              />
              <img v-if="inviteImg" :src="inviteImg" />
              <span>{{ inviteName }}</span>
            </span>
          </span>
          <span class="right" v-if="!inviteImg" @click="tuiguang">绑定</span>
          <span class="right" v-else style="opacity: 0.5" >已绑定</span>
        </div>
        <div class="one">
          <span class="left left1">
            <span>实名认证 <span v-if="idcard">：已认证</span></span>
			
            <span v-if="!idcard" style="display: flex"
              ><input type="text" placeholder="姓名" v-model="username" />
              <input
                class="chang"
                type="text"
                placeholder="身份证号码"
                v-model="card"
            /></span>
          </span>
          <span class="right" @click="shiming" v-if="!idcard">确定</span>
          <span class="right" v-else style="opacity: 0.5">已认证</span>
        </div>
        <div
          class="one"
          :style="idcard == true ? 'margin-top: 16px;' : 'margin-top: 0px;'"
        >
          <span class="left left1">
            <span>交易链接</span>
            <span>
              <input
                type="text"
                class="ccc"
                placeholder="请输入内容"
                v-model="dlist.trading"
              />
            </span>
            <div>
              <span class="rrr" @click="goUrl(url1)">前往STEAM获取</span>
              <span class="rrr" @click="goUrl(url2)">帮助中心</span>
            </div>
          </span>
          <span class="right" @click="confirm">更改/绑定</span>
          <!-- <span class="right1" v-else>
						<div @click="datalist.trading = false">取消</div>
						<div @click="confirm">保存</div>
					</span> -->
        </div>
        <!-- <div class="extend1" v-if="datalist.trading">
					<span>短信验证<input type="text" placeholder="请输入短信验证码" class="long" v-model="dlist.tradingCode"></span>
					<span @click="getCode(1)">获取验证码</span>
				</div> -->
      </div>

      <div class="me-title" style="color: #999">
        ※
        <span style="color: red">取回饰品</span
        >需要绑定Steam交易链接，请确保您的报价链接有效，且设置Steam库存为公开
      </div>

      <!-- 	<div class="invite">
				<div class="invite-list" v-if="inviteImg">
					<img v-if="inviteImg" :src="inviteImg" />
					<span>{{ inviteName }}</span>
				</div>
				<div class="invite-list1" v-if="!inviteImg">
					新用户3天内可以绑定上级<span @click="openTop">绑定</span>
				</div>
			</div>

			<div class="me-title">账号管理</div>

			<div class="number">
				<div class="number1">
					<span>手机: {{ Data.mobile }}</span><i class="el-icon-edit"></i>
				</div>
				<div class="number1">
					<span>邮箱绑定 {{ Data.email }}</span><span class="number-span" @click="openEmail">绑定</span>
				</div>
				<div class="number1">
					<span>修改密码</span><i class="el-icon-edit" @click="openPass"></i>
				</div>
			</div>

			<div class="me-title">偏好设置</div>

			<div class="hobby">
				<el-checkbox class="hobby1" v-model="checked1">开启声音 / 关闭声音</el-checkbox>
				<el-checkbox class="hobby1 hobby2" v-model="checked2">
					活动结果提醒（参与活动结束后结果会通过浏览器通知告知）</el-checkbox>
			</div> -->
    </div>

    <span :plain="true">{{ urlHint }}</span>

    <!-- 邮箱弹框 -->
    <div class="hide-box">
      <div class=""></div>
    </div>
    <!-- <navheader :showNav="showNav" :yidongmenu="yidongmenu"></navheader> -->
  </div>
</template>

<script>
import Utils from "./../assets/js/util.js";
import navheader from "@/components/navheader.vue";
export default {
  inject: ["reload"],
  components: {
    navheader,
  },
  props: ["yidongmenu", "showNav"],
  data() {
    return {
      datalist: {
        touxiang: false,
        userName: false,
        passWord: false,
        trading: false,
      },
      dlist: {
        touxiang: null,
        userName: null,
        passWord: null,
        passWordCode: null,
        trading: null,
        tradingCode: null,
      },
      inviteImg: "",
      inviteName: "",
      site: "",
      idcard: 0,
      card: "",
      tuiguangren: "",
      username: "",
      time: "",
      url: "",
      url1: "https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url",
      url2: "https://www.bilibili.com/video/BV15D4y1X79w/",
      urlState: true,
      checked1: false,
      checked2: false,
      flag: false,
      Data: {},
      urlHint: "",
      selectToux: 0,
      touxiang: [
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/1.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/2.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/3.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/4.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/5.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/6.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/7.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/8.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/9.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/10.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/11.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/12.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/13.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/14.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/15.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/16.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/17.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/18.png",
        },
        {
          img: "https://69csgoskins.oss-cn-beijing.aliyuncs.com/profile%20picture/19.png",
        },
      ],
    };
  },
  mounted() {
    this.getAvatar()
    this.getList();
  },
  methods: {
    // 获取头像数据
    getAvatar() {
      this.$axios.post('/api/player/playimglist',{page:1,pageSize:20})
      .then((res) => {
        // console.log(res,'res')
        if(res.data.code == 1) {
          let data = res.data.data
          data = data.sort((a,b) => b.is_default - a.is_default)
          this.touxiang = data
        }
      })
    },
    changePhoto() {
      var _this = this;
      let param = {
        id: this.touxiang[this.selectToux].id,
      };
      this.$axios
        .post("/api/player/editheadimages", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          // console.log(data);
          if (data.code == "1") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            _this.Data.image = _this.touxiang[this.selectToux].image
            Utils.$emit("img", _this.Data.image);
            this.chushihua();
          } else {
            this.$message({
              message: "修改失败",
              type: "info",
            });
          }
        });
    },
    changeToux(index) {
      this.selectToux = index;
    },
    handleChange(file, fileList) {
      let _this = this;
      let formData = new FormData();
      formData.append("player_id", _this.$store.state.id);
      formData.append("file", file.raw);
      //--------------
      _this
        .$axios({
          url: "/index/User/editHeadImage",
          method: "post",
          dataType: "json",
          data: formData,
          // processData: false,
          // contentType: false,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // headers:{'Content-Type':'application/x-www-form-urlencoded'}
        })
        .then((res) => {
          // console.log(res);
          if (res.data.status == 1) {
            _this.Data.img = res.data.data;
            Utils.$emit("image", _this.Data.img);
            _this.reload();
          }
        });
      // this.fileList = fileList.slice(-3);
    },
    //跟换头像
    getImg(response, file, fileList) {
      return;
    },
    chushihua() {
      this.datalist = {
        touxiang: false,
        userName: false,
        passWord: false,
        trading: false,
      };
      this.$forceUpdate();
      // this.dlist = {
      // 	touxiang: null,
      // 	userName: null,
      // 	passWord: null
      // }
    },
    //更换昵称
    getName() {
      let param = {
        name: this.dlist.userName,
      };
      this.$axios
        .post("/api/player/editnickname", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          // console.log(data);
          if (data.code == "1") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getList();

            this.chushihua();
          } else {
            this.$message({
              message: "修改失败",
              type: "info",
            });
          }
        });
    },
    shiming() {
      let param = {
        idcard: this.card,
        name: this.username,
      };
      this.$axios
        .post("/api/player/realname", this.$qs.stringify(param))
        .then((res) => {
          // console.log(res.data,'ooooooooooooooo');
          var data = res.data;
          if (data.code == "1") {
            this.$message({
              message: data.msg,
              type: "success",
            });
            this.idcard = true;
          } else {
            this.$message({
              message: data.msg,
              type: "error",
            });
          }
        });
    },
    //邮箱绑定
    openEmail() {
      this.$prompt("请输入邮箱", "邮箱绑定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern:
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
      })
        .then(({ value }) => {
          // console.log(value);
          let param = {
            email: value,
          };
          this.$axios
            .post("/index/User/bindEmail", this.$qs.stringify(param))
            .then((res) => {
              var data = res.data;
              // console.log(data);
              if (data.status == "1") {
                this.$message({
                  message: "绑定成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "绑定失败",
                  type: "info",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    //修改密码
    openPass() {
      let param = {
        password: this.dlist.passWord,
        code: this.dlist.passWordCode,
      };
      this.$axios
        .post("/api/player/editpass", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          // console.log(data);
          if (data.code == "1") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getList();
            this.chushihua();
          } else {
            this.$message({
              message: data.msg,
              type: "error",
            });
          }
        });
    },
    //绑定上级
    openTop() {
      this.$prompt("请输入邀请码", "绑定上级", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let param = {
            invite_code: value,
          };
          this.$axios
            .post("/api/player/bindinviter", this.$qs.stringify(param))
            .then((res) => {
              var data = res.data;
              console.log(data);
              if (data.code == "1") {
                this.$message({
                  message: "绑定成功",
                  type: "success",
                });
                this.reload();
              } else {
                this.$message({
                  message: "绑定失败，" + data.msg,
                  type: "info",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    //个人中心信息
    getList() {
      let param = {};
      this.$axios
        .post("/api/player/playerdata", this.$qs.stringify(param))
        .then((res) => {
          console.log(res.data);
          var data = res.data;
          if (data.code == "1") {
            this.Data = data.data.player;
            this.idcard = data.data.player.is_realname;
            this.dlist.trading = this.Data.tradeUrl;
            if (this.url) {
              this.flag = true;
            }
            // this.site = this.Data.last_login_info.position;
            // this.time = this.Data.last_login_info.time;
            if (data.data.player.myinviter) {
              this.inviteImg = data.data.player.myinviter.image;
              this.inviteName = data.data.player.myinviter.name;
            }
          }
        });
    },
    tuiguang() {
      let param = {
        invite_code: this.tuiguangren,
      };
      this.$axios
        .post("/api/player/bindinviter", this.$qs.stringify(param))
        .then((res) => {
          var data = res.data;
          console.log(data);
          if (data.code == "1") {
            this.$message({
              message: "绑定成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "绑定失败，" + data.msg,
              type: "info",
            });
          }
        });
    },
    //复制用户ID 和 steamid
    copyText(text) {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = text; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    //steam教程
    goUrl(url) {
      window.open(url, "_blank");
    },
    off() {
      this.urlState = true;
    },
    confirm() {
      //console.log(this.url);
      let param = {
        tradeUrl: this.dlist.trading,
        code: this.dlist.tradingCode,
      };
      this.$axios
        .post("/api/player/bindsteam", this.$qs.stringify(param))
        .then((res) => {
          // console.log(res.data);
          var data = res.data;
          if (data.code == "1") {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
            });
            this.$parent.getList();
            this.chushihua();
            this.urlState = true;
            this.flag = true;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error",
            });
            this.urlState = true;
            // this.url = '';
          }
        });
    },
    getCode(e) {
      var url = "/index/User/getsteamCode";
      if (e == 0) {
        url = "/index/User/getpasswordCode";
      }
      this.$axios.post(url).then((res) => {
        // console.log(res.data);
        var data = res.data;
        if (data.status == "1") {
          console.log(data);
          this.$message({
            showClose: true,
            message: data.msg,
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: data.msg,
            type: "error",
          });
          // this.url = '';
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.me {
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  // background-color: #1a1c24;
  // background-color: #06090f;
  background-image: url(../assets/img/bg-move.jpg) !important;
  background-size: 100% 100%;
  background-position: 0px 70px;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  .me-warp {
  }

  .me-title1 {
    margin-top: 16px;
    margin-left: 12px;
    // padding: 16px 0;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    line-height: 24px;
    opacity: 0.7;
  }

  .me-title {
    padding: 16px 12px;
    color: #c3c3e2;
    font-size: 10px;
  }

  .me-tou {
    background: rgba(71, 201, 243, 0.14);
    border-radius: 4px;
    // padding: 40px 30px;
    margin-top: 20px;
    padding: 0 12px;

    .extend {
      width: 100%;
      background: rgba(71, 201, 243, 0.3);
      border-radius: 4px;
      margin-top: 10px;
      padding: 25px 70px;
      font-size: 11px;
      font-weight: 400;
      color: #adb8ba;
      line-height: 16px;
    }

    .extend1 {
      width: calc(100%);
      background: rgba(71, 201, 243, 0.3);
      border-radius: 4px;
      margin-top: 10px;
      padding: 25px 8px;
      font-size: 10px;
      font-weight: 400;
      color: #adb8ba;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span:first-child {
        font-size: 12px;
      }

      span:last-child {
        display: block;
        width: 90px;
        height: 28px;
        font-size: 13px;
        background-repeat: no-repeat;
        background-size: 100%;
        line-height: 30px;
        background-image: url("../assets/img/my/button.png");
        font-weight: 400;
        color: #fff;
        text-align: center;
        cursor: pointer;
      }

      input {
        width: 100px;
        height: 25px;
        padding-left: 3px;
        margin-left: 12px;
        color: #fff;
        outline: none;
        font-size: 12px;
        opacity: 0.9;
        background: rgba(23, 188, 241, 0.2);
        border-radius: 4px;
        border: 0;
      }
    }

    .touxiang {
      width: 90%;
      background: rgba(71, 201, 243, 0.3);
      border-radius: 4px;
      margin-top: 10px;
      padding: 12px 12px;
      font-size: 11px;
      font-weight: 400;
      color: #adb8ba;
      line-height: 16px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      height: 180px;
      overflow-y: auto;
      justify-content: space-between;

      div {
        width: 70px;
        margin-top: 4px;

        div {
          cursor: pointer;
          width: 60px;
        }
      }

      img {
        width: 60px;
        border-radius: 50%;
      }

      .selectToux {
        box-shadow: 0 0 6px 0 rgba(71, 201, 243, 0.64);
        border-radius: 50%;
        border: 2px solid #47c9f3;
      }
    }

    .one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 21px;
      margin-top: 18px;
      min-height: 50px;

      .left {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 10px;
        color: #adb8ba;
        font-family: "微软雅黑";

        span:first-child {
          width: 58px;
        }

        span:last-child {
          font-weight: 600;
        }

        img {
          border-radius: 50%;
          width: 40px;
          height: 40px;
        }

        input {
          width: 100px;
          height: 25px;
          color: #fff;
          outline: none;
          opacity: 0.9;
          background: rgba(23, 188, 241, 0.2);
          border-radius: 4px;
          font-size: 10px;
          border: 0;
        }

        .long {
          width: 100%;
          font-size: 10px;
          padding-left: 8px;
        }
        .ccc {
          width: 100%;
          height: 25px;
        }

        .chang {
          // margin-left: 12px;
          width: 100%;
          height: 25px;
          font-size: 10px;
          margin-top: 4px;
          color: #fff;
          outline: none;
          opacity: 0.9;
          background: rgba(23, 188, 241, 0.2);
          border-radius: 4px;
          border: 0;
        }

        span:last-child {
          width: 70%;
        }
      }

      .left1 {
        width: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-start;
        font-size: 10px;
        color: #adb8ba;
        font-family: "微软雅黑";
        div {
          display: flex;
          .rrr {
            width: auto !important;
            font-size: 8px;
            font-weight: 400 !important;
            color: #4becff;
            opacity: 0.7;
          }
          .rrr:last-child {
            margin-left: 12px;
          }
          .rrr:hover {
            opacity: 1;
          }
        }
        span {
          width: 70% !important;
        }
        span:first-child {
          width: 47px;
        }

        span:last-child {
          // font-weight: 600;
          display: flex;
          align-items: center;
        }

        img {
          border-radius: 50%;
          width: 40px;
          height: 40px;
        }

        input {
          width: 60px;
          height: 25px;
          padding-left: 0.8rem;
          color: #fff;
          outline: none;
          opacity: 0.9;
          background: rgba(23, 188, 241, 0.2);
          border-radius: 4px;
          font-size: 10px;
          border: 0;
        }

        .long {
          width: 80px;
          font-size: 10px;
        }
        .ccc {
          width: calc(100% + 53px);
          height: 25px;
        }

        .chang {
          // margin-left: 12px;
          width: 100%;
          height: 25px;
          font-size: 10px;
          margin-top: 0;
          color: #fff;
          outline: none;
          margin-left: 12px;
          opacity: 0.9;
          background: rgba(23, 188, 241, 0.2);
          border-radius: 4px;
          border: 0;
        }

        span:last-child {
          width: 60%;
        }
      }

      .right1 {
        display: flex;

        div:first-child {
          width: 60px;
          height: 20px;
          font-size: 13px;
          background-repeat: no-repeat;
          background-size: 100%;
          line-height: 20px;
          background-image: url("../assets/img/my/btn_3.png");
          font-weight: 400;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }

        div:last-child {
          width: 60px;
          height: 20px;
          font-size: 12px;
          background-repeat: no-repeat;
          background-size: 100%;
          line-height: 20px;
          background-image: url("../assets/img/my/button.png");
          font-weight: 400;
          color: #fff;
          margin-left: 6px;
          text-align: center;
          cursor: pointer;
        }
      }

      .right {
        cursor: pointer;
        width: 80px;
        height: 30px;
        font-size: 12px;
        background-repeat: no-repeat;
        font-weight: 400;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 25px;
        background-image: url("../assets/img/my/button.png");
        background-size: 100% 100%;
      }
    }

    .tou-left {
      width: 100px;
      // position: relative;
      // border-radius: 50%;

      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }

      span {
        // position: absolute;
        // bottom: 0;
        // left: 0;
        width: 100%;
        text-align: center;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-weight: 600;
        color: #848492;
        background-color: rgba(0, 0, 0, 0.7);

        .upload-demo {
          width: 80px;

          /deep/ .el-upload {
            width: 100%;

            .btn {
              width: 100%;
              color: #848492;
              background-color: rgba(0, 0, 0, 0.7);
              border-color: rgba(0, 0, 0, 0.7);
            }
          }
        }
      }

      span:hover {
        cursor: pointer;
      }
    }

    .tou-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 38px;

      .tou-right-top {
        .tou1 {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
          }

          .tou1-span1 {
            font-size: 14px;
            font-weight: 400;
            color: #c3c3e2;
          }

          .tou1-span2 {
            background-color: #858493;
            border-radius: 3px;
            font-size: 12px;
            padding: 0 8px;
          }

          i {
            margin-left: 15px;
            font-size: 20px;
            color: #858493;
          }

          i:hover {
            cursor: pointer;
            color: #e9b10e;
          }
        }

        .tou2 {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #848492;

          .tou2-name {
            margin-right: 20px;

            i:hover {
              cursor: pointer;
              color: #e9b10e;
            }
          }
        }
      }

      .tou-right-bot {
        padding-bottom: 10px;
        // display: flex;
        // float: left;
        display: flex;
        justify-content: space-between;

        span {
          color: #848492;
          font-size: 14px;
        }

        span:first-child {
          color: #c3c3e2;
        }
      }
    }
  }

  .url {
    padding: 16px;
    background-color: #2b2c37;
    border-radius: 5px;

    .url1 {
      font-size: 14px;
      color: #848492;
    }

    .url2 {
      margin-top: 20px;
      display: flex;

      .url2-input {
        width: 380px;
        min-width: 100px;

        input {
          height: 40px;
          line-height: 40px;
          padding: 0 10px;
          border-radius: 5px;
          width: 100%;
          color: #c3c3e2;
          font-size: 12px;
          background-color: #24252f;
          outline: none;
          box-sizing: border-box;
          border: none;
        }
      }

      .url2-btn {
        span {
          display: inline-table;
          height: 40px;
          margin-left: 20px;
          line-height: 40px;
          padding: 0 20px;
          background-color: #e9b10e;
          border-radius: 5px;
          font-weight: 600;
          color: #1a1c24;
          font-size: 15px;
          white-space: nowrap;
        }

        span:hover {
          cursor: pointer;
          background-color: #f5c432;
        }

        .url2-btn {
          background-color: #333542;
          color: #848492;
        }

        .url2-btn:hover {
          background-color: #3a3f50;
        }
      }
    }

    .url3 {
      margin-top: 20px;

      div {
        margin-right: 20px;
        font-size: 14px;
        color: #c3c3e2;

        strong {
          color: #e9b10e;
        }

        strong:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .invite {
    padding: 16px;
    background-color: #2b2c37;
    border-radius: 5px;

    .invite-list {
      display: flex;
      align-items: center;

      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }

      span {
        margin-left: 20px;
        font-size: 16px;
        color: #848492;
      }
    }

    .invite-list1 {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #c3c3e2;

      span {
        font-weight: 600;
        color: #e9b10e;
        margin-left: 10px;
      }

      span:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .number {
    padding: 10px 30px;
    background-color: #2b2c37;
    border-radius: 5px;

    .number1 {
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
      color: #848492;
      font-size: 16px;

      i {
        font-size: 20px;
      }

      i:hover {
        cursor: pointer;
        color: #e9b10e;
      }

      .number-span:hover {
        cursor: pointer;
      }
    }
  }

  .hobby {
    padding: 10px 30px;
    background-color: #2b2c37;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

    .hobby1 {
      padding: 15px 0;
    }
  }
}
</style>